// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const penguin = defineModel({
  id: "penguin",
  batchId: "future",
  name: "Penguin",
  tags: ["creature","penguin","low-poly","age-of-mcp","future","water"],
  summary: "A penguin — polar-coast fauna.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.07,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.026, 0.006, 0.018), color: "#e88a26", position: [0.012, 0.004, 0.022] },
      { geometry: new THREE.BoxGeometry(0.026, 0.006, 0.018), color: "#e88a26", position: [0.012, 0.004, -0.022] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#22252b", position: [0, 0.075, 0], scale: [0.95, 1.5, 0.95] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#f2efe8", position: [0.022, 0.07, 0], scale: [0.7, 1.4, 0.85] },
      { geometry: new THREE.IcosahedronGeometry(0.032, 0), color: "#22252b", position: [0.004, 0.14, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#f2efe8", position: [0.024, 0.135, 0], scale: [0.7, 0.9, 0.8] },
      { geometry: new THREE.ConeGeometry(0.009, 0.024, 4), color: "#e88a26", position: [0.044, 0.135, 0], rotation: [0, 0, -1.570796] },
      { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#15110c", position: [0.028, 0.148, 0.012] },
      { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#15110c", position: [0.028, 0.148, -0.012] },
      { geometry: new THREE.BoxGeometry(0.012, 0.06, 0.026), color: "#22252b", position: [-0.012, 0.075, 0.05], rotation: [0, 0, 0.4] },
      { geometry: new THREE.BoxGeometry(0.012, 0.06, 0.026), color: "#22252b", position: [-0.012, 0.075, -0.05], rotation: [0, 0, 0.4] },
      { geometry: new THREE.ConeGeometry(0.016, 0.026, 4), color: "#22252b", position: [-0.04, 0.04, 0], rotation: [0, 0, 1.9] },
    ],
  animations: [],
});
